import withIcon from './NewIcon';
// @ts-ignore
import IconArrowDownNav from './icon/nav/arrow-down.s.svg';

export default withIcon(IconArrowDownNav);
